import { createTermTagManager } from '../../utils/createTermTagManager';

/**
 * @todo: Код появился в задаче CD-250097, удалить в задаче CD-250490.
 */
export const blackFridayEtazhiTagManager = createTermTagManager({
  jsonQueryKey: 'is_black_friday_etazhi',
  id: 'etazhiBlackFriday',

  /**
   * Это дефолтное значение, на уровне контейнера тегов оно может быть переопределено - требование продукта.
   */
  label: 'Чёрная пятница',
});
